import { motion } from 'framer-motion'
import styled, { css } from 'styled-components/macro'
import { Overlay, styleReset } from 'styles/misc'
import { mq } from 'styles/mq'

export const Button = styled.button<{ $isOpen: boolean }>`
  ${styleReset}
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 1.2rem;
  color: #555;
  height: var(--mobile-menu-button-height);
  cursor: pointer;
  z-index: 1000;
  background-color: white;

  svg {
    transition: transform 0.3s;
  }

  ${props =>
    !props.$isOpen &&
    css`
      svg {
        transform: rotateZ(180deg);
      }
    `}

  ${mq.medium} {
    display: none;
  }
`

export const MenuContainer = styled(motion.div)`
  ${Overlay}
  position: fixed;
  padding: var(--header-height) 2rem var(--mobile-menu-button-height);
  overflow: auto;
  background-color: white;
  z-index: 100;
`
